<template>
    <div class="w-100 h-100 text-center">
        <h1 class="display-2">
            {{title}}
        </h1>

        <input type="file" @change="onFileSelected">

        <b-button @click="onUpload()" variant="success">Upload</b-button>

    <b-container fluid>
      <b-row>
        <b-col md="8" lg="6" xl="4" offset-md="2" offset-lg="3" offset-xl="4">
            <b-container class="text-left bg-white" fluid>
                <b-row class="border-bottom mx-1">
                    <b-col cols="9">
                        Total Rows:
                    </b-col>
                    <b-col cols="3">
                        {{ totalRows }}
                    </b-col>
                </b-row>
                <b-row class="border-bottom mx-1">
                    <b-col cols="9">
                        Successful Rows:
                    </b-col>
                    <b-col cols="3">
                        {{ successRows }}
                    </b-col>
                </b-row>
                <b-row class="border-bottom mx-1">
                    <b-col cols="9">
                        Error Rows:
                    </b-col>
                    <b-col cols="3">
                        {{ errorRows }}
                    </b-col>
                </b-row>
                <b-row class="mx-1">
                    <b-col cols="9">
                        Output File with Errors:
                    </b-col>
                    <b-col cols="3">
                        {{ outputFile }}
                    </b-col>
                </b-row>
            </b-container>
        </b-col>
      </b-row>
    </b-container>
        
    </div>
</template>

<script>
    import {
        HTTP
    } from '@/utilities/http-common';
    import HandleErrors from '@/utilities/handle-errors';

    import DashboardBaseTemplate from '@/layouts/DashboardBaseTemplate.vue'

    export default {
        mixins: [
            DashboardBaseTemplate
        ],
        components: {},
        props: {},
        data: function () {
            return {
                title: 'Upload CSV',
                selectedFile: null,
                totalRows: 0,
                successRows: 0,
                errorRows: 0,
                outputFile: null
            }
        },
        computed: {},
        created: function () {

        },
        mounted: function () {

        },
        methods: {
            // ...mapActions('sample', ['nameOfAction']),
            get: function () {
                // HTTP.get('/').then((response) => {
                //     let something = response.data;
                // }).catch((error) => {
                //     HandleErrors.HandleErrors(error);
                // });
            },
            find: function () {

            },
            create: function () {

            },
            patch: function () {

            },
            update: function () {

            },
            delete: function () {

            },
            onFileSelected: function(event) {
                this.selectedFile = event.target.files[0];
            },
            onUpload: function() {
                const fd = new FormData();
                fd.append('file', this.selectedFile, this.selectedFile.name);
                HTTP.post('/kenya/upload-subject-microscopy/', fd).then((response) => {
                    response.data;
                }).catch((error) => {
                    HandleErrors.HandleErrors(error);
                });
            }
        }
        // beforeRouteEnter(to, from, next) {
        //     // called before the route that renders this component is confirmed.
        //     // does NOT have access to `this` component instance,
        //     // because it has not been created yet when this guard is called!
        // },
        // beforeRouteUpdate(to, from, next) {
        //     // called when the route that renders this component has changed,
        //     // but this component is reused in the new route.
        //     // For example, for a route with dynamic params `/foo/:id`, when we
        //     // navigate between `/foo/1` and `/foo/2`, the same `Foo` component instance
        //     // will be reused, and this hook will be called when that happens.
        //     // has access to `this` component instance.
        // },
        // beforeRouteLeave(to, from, next) {
        //     // called when the route that renders this component is about to
        //     // be navigated away from.
        //     // has access to `this` component instance.
        // },
    }
</script>
